module.exports = __webpack_public_path__ + "img/depo.43964b66.png";